import styled from '@emotion/styled';
import { Gutter } from '../../utils';
import { ITheme } from '../../themer';

export const Grid = styled.div<{}, ITheme>`
	display: flex;
	flex-wrap: wrap;

	${Gutter.getWrapperStyles('horizontal')}
	${Gutter.getWrapperStyles('vertical')}
`;
